import { useState, useEffect } from 'react';
import axios from 'axios';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import MetaData from '../Layouts/MetaData';

const DriverDownloadApp = () => {
    const [androidAppUrl, setAndroidAppUrl] = useState("");
    const [iosAppUrl, setIosAppUrl] = useState("");

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const { data } = await axios.get('/api/v1/header-settings');
                setAndroidAppUrl(data.settings.driverAndroidAppUrl || "");
                setIosAppUrl(data.settings.driverIosAppUrl || "");
            } catch (error) {
                console.error('Failed to load driver app download settings', error);
            }
        };
        fetchSettings();
    }, []);

    return (
        <>
            <MetaData title="Download the Driver App | 1313 Mart" />

            <main className="w-full sm:w-[80%] max-w-3xl m-auto mt-16 sm:mt-8 mb-16 px-3 sm:px-0">
                <div className="bg-primary-blue rounded-lg px-6 sm:px-12 py-14 text-white text-center mb-10">
                    <h1 className="text-3xl sm:text-4xl font-bold mb-3">1313 Mart Driver App</h1>
                    <p className="text-sm sm:text-base opacity-90 max-w-xl mx-auto">
                        For 1313 Mart delivery drivers only — manage your deliveries and share live location
                        with customers.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Android */}
                    <div className="bg-white rounded-lg shadow-sm p-8 flex flex-col items-center text-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-green-50 flex items-center justify-center">
                            <AndroidIcon sx={{ fontSize: "44px" }} className="text-primary-green" />
                        </div>
                        <h2 className="text-lg font-semibold text-gray-800">Android</h2>
                        {androidAppUrl ? (
                            <a
                                href={androidAppUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary-green text-white font-medium px-6 py-3 rounded-full shadow hover:shadow-lg w-full"
                            >
                                Download APK
                            </a>
                        ) : (
                            <span className="text-gray-400 text-sm border rounded-full px-6 py-3 w-full">
                                Not available yet
                            </span>
                        )}
                    </div>

                    {/* iOS */}
                    <div className="bg-white rounded-lg shadow-sm p-8 flex flex-col items-center text-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-gray-50 flex items-center justify-center">
                            <AppleIcon sx={{ fontSize: "44px" }} className="text-gray-800" />
                        </div>
                        <h2 className="text-lg font-semibold text-gray-800">iOS</h2>
                        {iosAppUrl ? (
                            <a
                                href={iosAppUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-gray-900 text-white font-medium px-6 py-3 rounded-full shadow hover:shadow-lg w-full"
                            >
                                Download on the App Store
                            </a>
                        ) : (
                            <span className="text-gray-400 text-sm border rounded-full px-6 py-3 w-full">
                                Not available yet
                            </span>
                        )}
                    </div>
                </div>
            </main>
        </>
    );
};

export default DriverDownloadApp;